import {LabelInterface} from "../../../interfaces/product/product.interface";
import React from "react";
import Success from '../../../assets/images/labels/success.svg';
import Warning from '../../../assets/images/labels/warning.svg';
import Error from '../../../assets/images/labels/error.svg';

interface ProductLabelsProps {
    label: LabelInterface;
}

const ProductLabel: React.FC<ProductLabelsProps> = ({ label }) => {
    let color, icon;

    switch (label.type) {
        case "success":
            color = '#78BA66';
            icon = Success;
            break;
        case "warning":
            color = '#FFCC33';
            icon = Warning;
            break;
        case "error":
            color = '#E73140';
            icon = Error;
            break;
        default:
            color = '#78BA66';
            icon = Success;
    }

    return (
        <div
            className="border-2 rounded-xl px-4 py-2 flex items-center gap-2"
            style={{borderColor: color}}
        >
            <img className="shrink-0" src={ icon } alt={ label.type }/>
            <span className="text-[14px] text-gray whitespace-nowrap">{label.text}</span>
        </div>
    );
};

export default ProductLabel;